import { Injectable } from '@angular/core';
import { IActionConfig } from 'interfaces-lib';

@Injectable({ providedIn: 'root' })
export class TriggerAccordianService {
  private defaultTriggers: any = [
    { id: 'post-SaveToEntity', type: 'action' },
    { id: 'post-SendForSignature', type: 'action' },
    { id: 'post-ReceivedFromSignature', type: 'action' },
  ];

  public addMissingDefaultTriggers(actions: IActionConfig[]) {
    // Jackson settings serverside strip actions of properties with no actions
    actions.forEach((action) => {
      action.properties = action.properties ?? {};
      (action.properties as { [key: string]: any }).actions = (action.properties as { [key: string]: any }).actions ?? [];
    });

    this.defaultTriggers.forEach((defaultTrigger) => {
      if (actions.find((action) => action.id === defaultTrigger.id)) {
        return;
      }
      actions.push(this.newEmptyTrigger(defaultTrigger.id, defaultTrigger.type));
    });
  }

  private newEmptyTrigger(id: string, type: string) {
    return {
      id: id,
      type: type,
      properties: {
        actions: [],
      },
    };
  }
}
